import { get } from '@rails/request.js'

import ApplicationController from '@/controllers/application_controller'

export default class extends ApplicationController {
  static values = {
    url: String,
  }

  static targets = ['price', 'skeleton']

  async onCountryChange({ target }) {
    this.hide(...this.priceTargets)
    this.show(...this.skeletonTargets)

    await get(this.urlValue.replace(':country_id', target.value), {
      responseKind: 'turbo-stream'
    })

    this.hide(...this.skeletonTargets)
    this.show(...this.priceTargets)
  }
}
